import React, { useCallback } from 'react';
import {
	RichTextEditor as BaseRichTextEditor,
	RichTextEditorBaseProps,
	LegacyPassThroughProps,
} from '@RichTextEditor';
import { uploadPicture } from '@Services/uploads/uploads.req';
import { useSnackbar } from '@Providers/useSnackbar';

type Props = RichTextEditorBaseProps & LegacyPassThroughProps;

/**
 * App wrapper around the shared @eduact/rich-text-editor: injects the
 * app-specific upload service and snackbar.
 */
const RichTextEditor: React.FC<Props> = (props) => {
	const { displaySnackbar } = useSnackbar();

	const uploadImage = useCallback(async (file: File) => {
		const {
			data: {
				data: { uri },
			},
		} = await uploadPicture({ folder: 'tinymc', photo: file });
		return uri;
	}, []);

	return (
		<BaseRichTextEditor
			{...props}
			uploadImage={uploadImage}
			onError={(message) => displaySnackbar('error', message)}
		/>
	);
};

export default RichTextEditor;
